import { flightModeStyle } from './style'

export const TimeControl = ({ onChange, value, log }) => {
  const time = '18:00'
  const handleChange = (val) => {
    if(log)
      console.log('TimeControl', val)

    if(onChange)
      onChange(val)
  }

  return (
    <input style={flightModeStyle.input} type="time" onChange={(e) => handleChange(e.target.value)} value={value} />
  )
}
